import ApiService from "@/services/api.service";
import { UserService } from "@/services/user.service";

class FetchingError extends Error {
    constructor(errorCode, message) {
        super(message)
        this.name = this.constructor.name
        this.message = message
        this.errorCode = errorCode
    }
}

const EventsService = {
    fetchEvents: async function(options = {}) {
        const user_roles = UserService.getUserData('user_roles').split(";");
        const requestData = {
            method: 'post',
            url: "/p/events",
            data: {
                user_roles: user_roles,
                user_id: UserService.getUserData('user_id'),
                options: options
            }
            // auth: {
            //     username: process.env.VUE_APP_CLIENT_ID,
            //     password: process.env.VUE_APP_CLIENT_SECRET
            // }
        }

        try {
            const response = await ApiService.customRequest(requestData)
            ApiService.setHeader()

            return response.data.events
        } catch (error) {
            throw new FetchingError(error.response.status, error.response.data.message)
        }
    },
    fetchUserRoles: async function() {
        const requestData = {
            method: 'post',
            url: "/p/user_roles",
            // auth: {
            //     username: process.env.VUE_APP_CLIENT_ID,
            //     password: process.env.VUE_APP_CLIENT_SECRET
            // }
        }

        try {
            const response = await ApiService.customRequest(requestData)
            ApiService.setHeader()

            return response.data.user_roles
        } catch (error) {
            throw new FetchingError(error.response.status, error.response.data.message)
        }
    },
    fetchEvent: async function(event_id) {
        const requestData = {
            method: 'post',
            url: "/p/event",
            data: {
                user_id: UserService.getUserData('user_id'),
                event_id: event_id
            }
            // auth: {
            //     username: process.env.VUE_APP_CLIENT_ID,
            //     password: process.env.VUE_APP_CLIENT_SECRET
            // }
        }

        try {
            const response = await ApiService.customRequest(requestData)
            ApiService.setHeader()

            return response.data.event
        } catch (error) {
            throw new FetchingError(error.response.status, error.response.data.message)
        }
    },
    saveApplication: async function (event_id, application_data) {
        // console.log(application_data);
        const requestData = {
            method: 'post',
            url: "/p/save_application",
            data: {
                user_id: UserService.getUserData('user_id'),
                event_id: event_id,
                application_data: application_data
            }
            // auth: {
            //     username: process.env.VUE_APP_CLIENT_ID,
            //     password: process.env.VUE_APP_CLIENT_SECRET
            // }
        }

        try {
            const response = await ApiService.customRequest(requestData)
            ApiService.setHeader()

            return response.data.event
        } catch (error) {
            throw new FetchingError(error.response.status, error.response.data.message)
        }
    },
    saveEvent: async function (event_data) {
        const requestData = {
            method: 'post',
            url: "/p/save_event",
            data: {
                event_data: event_data
            }
            // auth: {
            //     username: process.env.VUE_APP_CLIENT_ID,
            //     password: process.env.VUE_APP_CLIENT_SECRET
            // }
        }

        try {
            const response = await ApiService.customRequest(requestData)
            ApiService.setHeader()

            return response.data.event
        } catch (error) {
            throw new FetchingError(error.response.status, error.response.data.message)
        }
    },
    deleteEvent: async function (event_data) {
        const requestData = {
            method: 'post',
            url: "/p/delete_event",
            data: {
                event_data: event_data
            }
        }

        try {
            const response = await ApiService.customRequest(requestData)
            ApiService.setHeader()

            return response.data.event
        } catch (error) {
            throw new FetchingError(error.response.status, error.response.data.message)
        }
    },
    deleteAgenda: async function (event_data) {
        const requestData = {
            method: 'post',
            url: "/p/unset_event_agenda",
            data: {
                event_data: event_data
            }
        }

        try {
            const response = await ApiService.customRequest(requestData)
            ApiService.setHeader()

            return response.data.event
        } catch (error) {
            throw new FetchingError(error.response.status, error.response.data.message)
        }
    },
    updateApplicationStatus: async function (event_id, status_data) {
        const requestData = {
            method: 'post',
            url: "/p/update_application_status",
            data: {
                user_id: UserService.getUserData('user_id'),
                event_id: event_id,
                status_data: status_data
            }
            // auth: {
            //     username: process.env.VUE_APP_CLIENT_ID,
            //     password: process.env.VUE_APP_CLIENT_SECRET
            // }
        }

        try {
            const response = await ApiService.customRequest(requestData)
            ApiService.setHeader()

            return response.data.event
        } catch (error) {
            throw new FetchingError(error.response.status, error.response.data.message)
        }
    },
}

export default EventsService

export { EventsService, FetchingError }